import { http } from '../../config/axios'

export default function putNotificacao(notificacao: any): Promise<string> {
  return http
    .put('api/notificacao', notificacao)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put notificacao', error)
      throw Error(error.response.data)
    })
}
